<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование файла') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12 mt-1">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <v-row>
          <v-col>
            <v-row
                class="grey lighten-2 rounded mt-2"
                rounded>
              <v-col cols="12">
                <v-row v-if="dialogProp.file">
                  <text-view
                      v-if="dialogProp.file.fileName"
                      :display="dialogProp.file.fileName"
                      :label="$t('Редактируемый файл')" />
                  <text-view
                      v-if="dialogProp.file.staticFileType"
                      :display="$t(STATIC_FILE_TYPE_ENUM[dialogProp.file.staticFileType])"
                      :label="$t('Тип файла')" />
                </v-row>
                <static-file-input
                    v-if="dialogProp.file.staticFileType"
                    icon="attach_file"
                    :accept="fileExt"
                    @change="fileSelected" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert
                class="text-center ma-1"
                outlined
                :value="!!fileExt"
                type="info">
              {{ $t('Возможна загрузка файла с расширением ') + `${fileExt}` }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="file">
          <text-view
              v-if="fileName"
              :display="fileName"
              :label="$t('Загружаемый файл')" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading || !file"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import StaticFileInput from '@/components/reused/ui/StaticFileInput.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { STATIC_PAGES } from '@/constants/store.js'
  import { STATIC_FILE_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      TextView,
      GeneralError,
      StaticFileInput
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            file: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        STATIC_FILE_TYPE_ENUM,
        isLoading: false,
        fileName: null,
        file: null
      }
    },
    computed: {
      staticFileTypes () {
        return Object.keys(STATIC_FILE_TYPE_ENUM).map(key => {
          return {
            type: key,
            description: this.$t(STATIC_FILE_TYPE_ENUM[key])
          }
        })
      },
      fileExt () {
        const fileName = this.dialogProp.file.fileName
        return fileName.substring(fileName.indexOf('.'))
      }
    },
    watch: {
    },
    created () {
    },
    methods: {
      ...mapActions(STATIC_PAGES.NAMESPACE, {
        uploadStaticFileAction: STATIC_PAGES.ACTIONS.UPLOAD_STATIC_FILE,
        editStaticFileAction: STATIC_PAGES.ACTIONS.EDIT_STATIC_FILE
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearFullPageInfoAction()
          ])
      },
      fileSelected: function (file) {
        const form = new FormData()
        // form.append('path', this.path)
        form.append('staticFileType', this.dialogProp.file.staticFileType)
        form.append('file', file.file, file.name)
        this.file = form
        this.fileName = file.name
      },
      editStaticFile: async function (file) {
        await this.editStaticFileAction({
          fileId: this.dialogProp.file.fileId,
          file
        })
      },
      continueOperation: async function () {
        if (!this.file) {
          throw new Vue.errorsTypes.ValidationError(this.$t('Файл не выбран'))
        }
        try {
          this.isLoading = true
          await this.editStaticFile(this.file)

          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
